import { useState } from 'react';
import { connect } from 'react-redux';
import {
  fetchCancellationReasons,
  refundOrder,
} from 'actions/orderCancellation';
import { resetOrder } from 'actions/orderSearch';

let _content = null;

const OrderAcceptComplete = (props) => {
  const { resetOrder, order, currentStaff } = props;

  const [redirect, setRedirect] = useState(false);
  const [orderNumber, setOrderNumber] = useState(null);
  const [successModal, setSuccessModal] = useState(true);

  const cleanStateAndRedirect = () => {
    resetOrder();
    setRedirect(true);
  };

  const closeModal = () => {
    setSuccessModal(false);
    setRedirect(true);
    setOrderNumber(order.number);
    resetOrder();
  };

  const printPage = () => {
    window.print();
  };

  return (
    _content &&
    _content({
      props,
      redirect,
      orderNumber,
      successModal,
      currentStaff,
      cleanStateAndRedirect,
      closeModal,
      printPage,
    })
  );
};

const mapDispatchToProps = {
  fetchCancellationReasons,
  refundOrder,
  resetOrder,
};

const mapStateToProps = (state) => ({
  order: state.orderRefund.order,
  orderItems: state.orderRefund.orderItems,
  refundInvoiceNumber: state.orderRefund.refundInvoiceNumber,
  error: state.orderRefund.error,
  pending: state.orderRefund.pending,
  cancellationReasons: state.orderRefund.cancellationReasons,
  currentStaff: state.staffs.currentStaff,
  success: state.orderRefund.success,
});

export default function (content) {
  _content = content;
  return connect(mapStateToProps, mapDispatchToProps)(OrderAcceptComplete);
}



// WEBPACK FOOTER //
// ./src/_pageContainers/orders/refund/orderRefundComplete/index.js